import type { WelcomeDelivery1ScreenModel } from './WelcomeDelivery1ModelScreen';

export class WelcomeDelivery1Controller {
  constructor(private readonly model: WelcomeDelivery1ScreenModel) {}

  handleContinue = () => {
    this.model.onContinue?.();
  };
}
